import { FormGroupHeader, DataTable } from "@/components/shared";
import { ActionButtonConfig } from "@/components/shared/FormGroupHeader";
import { useTranslation } from "react-i18next";
import { FetchBillingsDocument, FetchBillingsQuery, FetchBillingsQueryVariables } from "@/graphql/__generated__/graphql";
import { useState } from "react";
import CreateBillingDialog from "./CreateBillingDialog";
import { useIntl } from "react-intl";
import { RefreshCcwIcon } from "lucide-react";
import { getColumnsBillings } from "./columns";
import { useQuery } from "@apollo/client/react";

function BillingComponent() {
  const intl = useIntl();
  const { t } = useTranslation(["translation", "components", "tables", "common"]);

  const [openCreateBillingDialog, setOpenCreateBillingDialog] = useState(false);

  const { data, loading, refetch } = useQuery<FetchBillingsQuery, FetchBillingsQueryVariables>(FetchBillingsDocument,{
    fetchPolicy: "cache-and-network"
  });
  const billings = data?.fetchBillings;

  const actionButtons: ActionButtonConfig[] = [
    { text: "", icon: <RefreshCcwIcon />, actionFn: () => { refetch(); }, variant: "outline", size: "icon" },
    { text: t("admin.billings.newbilling"), actionFn: () => { setOpenCreateBillingDialog(true); }, variant: "default" }
  ];

  return (
    <div className="pb-[300px] pr-4 pl-2">
      <FormGroupHeader
        actionButtons={actionButtons}
        title={t("admin.billings.title")}
        description={t("admin.billings.description")}
      />

      <DataTable
        headerStyling="font-normal text-sm"
        disableRowColour={true}
        loading={loading}
        displayAmount={billings?.length ?? 5}
        data={billings ?? []}
        columns={getColumnsBillings(intl, t)}
        className="max-h-120"
      />

      <CreateBillingDialog open={openCreateBillingDialog} onOpenChange={setOpenCreateBillingDialog} />
    </div>
  );
}

export default BillingComponent;
